
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/formEle/index.md?watch=parent';
    export const toc = [{"id":"扩展元素","depth":2,"title":"扩展元素"}];
export const frontmatter = {"title":"表单元素全字段","toc":"menu","filename":"pages/pages/reference/formEle/index.md","lastUpdated":1773900960000,"description":"这是一个form表单元素全字段的动态表格"};